module.exports = __webpack_public_path__ + "img/polygon_large.241fbc3b.svg";